import { useMutation, useQueryClient } from "react-query";
import { Auth } from "../../interface";
import { mutatePostFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useAddKeyHostUser = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutatePostFn(ENDPOINTS.ADD_KEY_HOST_USER, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries(["keyHostDetails"]);
      },
    }
  );
};